// extracted by mini-css-extract-plugin
export default {"accordionWrapper":"CmsDownloadAccordion-module__accordionWrapper-d8KUtf","cardsGroup":"CmsDownloadAccordion-module__cardsGroup-yvcFp6"};